import { queryOptions } from '@tanstack/react-query';
import { getCard, getDueCards, getScheduledCards } from './card-fns';

export const cardQueryOptions = (pageNumber: number) =>
  queryOptions({
    queryKey: ['card', pageNumber],
    queryFn: () => getCard({ data: { pageNumber } }),
    staleTime: Number.POSITIVE_INFINITY,
  });

export const dueCardsQueryOptions = () =>
  queryOptions({
    queryKey: ['dueCards'],
    queryFn: () => getDueCards(),
    staleTime: Number.POSITIVE_INFINITY,
  });

export const scheduledCardsQueryOptions = () =>
  queryOptions({
    queryKey: ['scheduledCards'],
    queryFn: () => getScheduledCards(),
    staleTime: Number.POSITIVE_INFINITY,
  });
